<script setup lang="ts">
import { useCountDownInfo } from '@pet/23cny.countdown/utils';
import Box from '@pet/base.box/box.vue';
import { fillZero } from '@pet/base.utils';
import Separator from '@/pages/e-commerce/components/base-icons/Separator.svg.vue';
import { computed, watch } from 'vue';

const props = withDefaults(
    defineProps<{
        endTime: number;
        suffixText?: string;
    }>(),
    {
        suffixText: '后结束',
    },
);

const emit = defineEmits<{
    (e: 'finish'): void;
}>();

const endTime = computed(() => props.endTime);

const { day, hour, minute, second } = useCountDownInfo(endTime);

watch([day, hour, minute, second], async ([newDay, newHour, newMinute, newSecond]) => {
    if (newDay === 0 && newHour === 0 && newMinute === 0 && newSecond === 0) {
        emit('finish');
    }
});

const hourWithFillZero = computed(() => fillZero(hour.value));

const minuteWithFillZero = computed(() => fillZero(minute.value));

const secondWithFillZero = computed(() => fillZero(second.value));
</script>
<template>
    <Box class="count-down" justify="center" align="center">
        <span class="time">{{ hourWithFillZero }}</span>
        <Separator class="separator" />
        <span class="time">{{ minuteWithFillZero }}</span>
        <Separator class="separator" />
        <span class="time">{{ secondWithFillZero }}</span>
        <span class="text">{{ suffixText }}</span>
    </Box>
</template>
<style lang="less" scoped>
.count-down {
    margin-top: 12px;
    .text {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        margin-left: 6px;
    }
    .separator {
        margin: 0 3px;
        color: #fff;
    }
    .time {
        width: 20px;
        height: 16px;
        background-color: #fff;
        color: #ff2a46;
        text-align: center;
        font-size: 11px;
        font-weight: 500;
        line-height: 16px;
        border-radius: 5px;
    }
}
</style>
